import React, { useState } from 'react';
import { industries } from '../data/mock';
import IndustryModal from '../components/IndustryModal';
import { ArrowRight } from 'lucide-react';
import { industryImages } from '../data/images';

const IndustriesPage = () => {
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (industry, image) => {
    setSelectedIndustry(industry);
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedIndustry(null);
    setSelectedImage(null);
  };

  return (
    <div className="industries-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container-main">
          <div className="glass-card hero-content-card animate-fade-in">
            <h1 className="heading-1 text-primary mb-6">Industries We Serve</h1>
            <p className="body-large text-text-primary max-w-3xl">
              Delivering specialized design expertise across diverse manufacturing sectors
            </p>
          </div>
        </div>
      </section>

      {/* Industries Grid - 3 Columns - Industrial Style */}
      <section className="section-padding" style={{ background: 'var(--bg-section-alt)' }}>
        <div className="container-main">
          <div className="industries-industrial-grid">
            {industries.map((industry, idx) => (
              <div
                key={industry.id}
                className="industry-card-industrial"
                onClick={() => openModal(industry, industryImages[idx])}
              >
                <div className="industry-card-industrial-image">
                  <img
                    src={industryImages[idx]}
                    alt={industry.name}
                  />
                  <div className="industry-card-industrial-overlay"></div>
                </div>
                <div className="industry-card-industrial-content">
                  <h3 className="industry-card-industrial-title">{industry.name}</h3>
                  <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: '1rem' }}>
                    {industry.description}
                  </p>
                  <span className="service-read-more">
                    View Details <ArrowRight size={16} />
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industry Modal */}
      <IndustryModal
        isOpen={!!selectedIndustry}
        onClose={closeModal}
        industry={selectedIndustry}
        image={selectedImage}
      />
    </div>
  );
};

export default IndustriesPage;
